export const AVALANCHE_TOKEN_WHITELIST = [
    '0x49d5c2bdffac6ce2bfdb6640f4f80f226bc10bab'
]
export const AVALANCHE_TOKEN_BLACKLIST = []